module.exports = __webpack_public_path__ + "img/play-video.a5239092.png";